import { dateFormat, priceFormat } from '@cashew/utils';
import { ChargebackPayment } from './index.types';

const formatEligiblePayments = ({
  payments,
  currency,
}: {
  payments: ChargebackPayment[];
  currency: string;
}) =>
  payments?.map((payment) => ({
    key: payment.paymentId?.toString() || '',
    value: `${priceFormat({
      currency,
      amount: payment.amount || 0,
    })} paid on ${dateFormat({ date: payment.paymentDate! })}`,
  }));

export { formatEligiblePayments };
